// extracted by mini-css-extract-plugin
export var container = "_dp-0";
export var containerTopRight = "_dp-1";